// components/RootRedirect.js
import { Navigate } from 'react-router-dom';
import { useGetCurrentUserQuery } from '../store/user/userApi';

const RootRedirect = () => {
  const { data } = useGetCurrentUserQuery();
  if (data?.data.type === 'admins' || data?.data.type === 'super_admin' || data?.data?.type === 'partners') {
    return <Navigate to="/insights-admin" />;
  } else if (data?.data.type === 'staff') {
    return <Navigate to="/staff" />;
  }
  return <div className='flex flex-col w-full h-screen justify-center items-center'>
    <img src='/assets/staff/redirect.svg' />
    <p className='text-xl text-black text-center mt-5'>Redirecting you to La Dolce Vita Orient Express</p>
  </div>;

};

export default RootRedirect;
